// 通过本地存储获取登录信息
export function getMemInfo(){
  //  const memInfo = JSON.parse(localStorage.getItem('memInfo') || '{}');
  const memInfo = localStorage.getItem('memInfo') || '{}';
   return memInfo;
}
